import styled, { css, keyframes } from 'styled-components';

const fadeInAnimation = keyframes`
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

export const CarouselItemWrapper = styled.div.attrs({
    className: String('ap-carousel-item')
}) <{ $isActive: boolean; }>`
    display: inherit;
    position: absolute;
    overflow: hidden;
    height: 100%;
    width: 100%;
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    transition: opacity 1s;
    z-index: ${({ $isActive }) => ($isActive ? 1 : 0)};
    ${({ $isActive }) => $isActive && css`animation: ${fadeInAnimation} 1s;`}
`;
